export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14624.e90b5e40.jpg";